/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { WebsiteTypeSchema } from '../enums/WebsiteType.schema';
const baseSchema = z.object({
    type: WebsiteTypeSchema,
    url: z.string().min(1, { message: "Website must be between 1 and 100 characters." }).max(100, { message: "Website must be between 1 and 100 characters." }).url(),
    verifiedAt: z.coerce.date().nullish(),
    verifiedBy: z.string().nullish(),
}
).strict();
export const WebsiteSchema = baseSchema;
